import React from "react";
import {GridContainer} from "./QuestionParametersSection.styles";
import {QuestionSelectors} from "../../atoms/QuestionSelectors";
import {QuestionAutocompleteSection} from "../QuestionAutocompleteSection";

interface QuestionParametersSectionProps {
  prefix: string;
}

export default function QuestionParametersSection({ prefix }: QuestionParametersSectionProps) {
  return (
    <GridContainer container item spacing={4}>
      <QuestionSelectors prefix={prefix} />
      <QuestionAutocompleteSection prefix={prefix} />
    </GridContainer>
  );
}
